import React, { Component } from "react";
import { gql, graphql, ApolloClient } from "react-apollo";
import { connect } from "react-redux";

import { Loading, Breadcrumbs, Grid, Notifications, Tabs } from "components/UI";
import BuildingAlertTable from "./BuildingAlertTable";
import { withApollo } from "react-apollo/lib/withApollo";

const API_URL = "https://8knpyc9t3i.execute-api.us-east-1.amazonaws.com/dev";

class BuildingAlertList extends Component {
  constructor(props) {
    super(props);
    this.removeBuildingAlert = this.removeBuildingAlert.bind(this);
    this.removeUnitAlert = this.removeUnitAlert.bind(this);
  }

  manualRequest(query) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", this.props.userDetails.sub);
    let options = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ query })
    };
    fetch(API_URL, options)
      .then(r => r.json())
      .then(j => {
        if (!j.errors) {
          return this.props.client.resetStore();
        } else {
          console.log(j);
        }
      })
      .then(() => console.log("Store reset!"));
  }

  removeBuildingAlert(id) {
    this.manualRequest(`mutation{silenceBuildingAlert(id:${id}){description}}`);
  }

  removeUnitAlert(id) {
    this.manualRequest(`mutation{silenceUnitAlert(id:${id}){description}}`);
  }

  render() {
    const { match, data } = this.props;

    const { error, loading, building } = data;

    if (error) return <Notifications.Error message={error.message} />;

    const buildingId = match.params.buildingId;

    const breadcrumbs = [
      { name: "Alerts", to: `/alerts` },
      { name: loading ? "..." : building.name, to: `/alerts/${buildingId}` }
    ];

    return (
      <Grid>
        <Grid.Row>
          <Breadcrumbs items={breadcrumbs} />
        </Grid.Row>
        <Grid.Row>
          <Tabs
            panes={[
              {
                title: "Building Level Alerts",
                content: loading ? (
                  <Loading />
                ) : (
                  <BuildingAlertTable
                    data={building.buildingAlerts}
                    building
                    remover={this.removeBuildingAlert}
                  />
                )
              },
              {
                title: "Apartment Level Alerts",
                content: loading ? (
                  <Loading />
                ) : (
                  <BuildingAlertTable
                    data={building.unitAlerts}
                    unit
                    remover={this.removeUnitAlert}
                  />
                )
              }
            ]}
          />
        </Grid.Row>
      </Grid>
    );
  }
}

const BuildingAlertListQuery = gql`
  query BuildingAlertListQuery($id: Int!) {
    building(id: $id) {
      name
      buildingAlerts(active: true) {
        id
        type
        floor
        line
        description
        causes
        action
        severity
        timestamp
      }
      unitAlerts(active: true) {
        id
        type
        description
        causes
        action
        severity
        unit
        room
        count
        link
        radiator
        timestamp
      }
    }
  }
`;

const mapStateToProps = state => ({
  userDetails: state.auth.userDetails
});

export default graphql(BuildingAlertListQuery, {
  options: ({ match }) => ({
    variables: {
      id: match.params.buildingId
    },
    notifyOnNetworkStatusChange: true
  })
})(withApollo(connect(mapStateToProps)(BuildingAlertList)));



// WEBPACK FOOTER //
// ./src/components/Alert/BuildingAlertList.jsx